const IS_TESTING = window.location.hostname.includes("website-renoperfect-rrmr");

// 23/10/2026: de API- en websocket-adressen zijn bij de build te overschrijven via
// REACT_APP_API_BASE_URL en REACT_APP_WS_BASE_URL, voor de Hetzner-uitrol.
// Zonder die variabelen blijft het gedrag exact zoals vroeger (Render of lokaal).
const API_OVERRIDE = (process.env.REACT_APP_API_BASE_URL || "").trim();
const WS_OVERRIDE = (process.env.REACT_APP_WS_BASE_URL || "").trim();

const API_DEFAULT = process.env.NODE_ENV === 'production'
    ? (IS_TESTING ? "https://website-renoperfect-testing.onrender.com/api/"  : "https://website-renoperfect.onrender.com/api/")
    : "http://localhost:8000/api/";

const WS_DEFAULT = process.env.NODE_ENV === 'production'
    ? (IS_TESTING ? "wss://website-renoperfect-testing.onrender.com/ws/" : "wss://website-renoperfect.onrender.com/ws/")
    : "ws://localhost:8000/ws/";

export const API_BASE_URL = API_OVERRIDE || API_DEFAULT;

export const WS_BASE_URL = WS_OVERRIDE || WS_DEFAULT;


export const GOOGLE_MAPS_API_KEY = "AIzaSyA8N_y7d8W6PNSzcb4Lk1pj-uo6ucpsskE";
